import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ButtonWrapper = styled.button`
    border-radius: ${props => props.type === 'light' ? '20px' : '15px'};
    border-style: ${props => props.borderStyle ? props.borderStyle : 'none'};
    box-shadow: 5px 5px 5px #88888888;
    background: ${props => props.type === 'light' ? '#ffcc02' : '#3fa9b4'};
    font-size: ${props => props.size === 'small' ? '11px' : '14px'};
    height: ${props => props.size === 'small' ? '40px' : '50px'};
    width: ${props => props.size === 'small' ? '140px' : '180px'};
    color: ${props => props.type === 'light' ? 'black' : 'white'};
    margin: 1em;
    & > a {
        color: ${props => props.type === 'light' ? 'black' : 'white' };
    }
`

const CompanyPageButton = ({ type, children, onClick, size, disabled, borderStyle, ...styleProps }) => {
    return(
        <ButtonWrapper
            onClick={onClick}
            type={type}
            size={size}
            borderStyle={borderStyle}
            style={styleProps.buttonStyle}
            disabled={disabled}
        >
            { children }
        </ButtonWrapper>
    )
}

CompanyPageButton.propTypes = {
    /** Children to be rendered within the button, it could be of any type */
    children: PropTypes.any.isRequired,
    /** Type string that defines the button style */
    type: PropTypes.string,
    /** onClick function to be passed to the button */
    onClick: PropTypes.func.isRequired,
    /** Size string that determines the button measurements */
    size: PropTypes.string
}

CompanyPageButton.defaultProps = {
    children: 'Placeholder children',
    type: 'light',
    onClick: () => null,
    size: 'medium'
}

export default CompanyPageButton;




// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyPageButton.jsx